class EncodingFiltersService {
  static encode(params) {
    if (params == null) return;
    let sort;
    const { fields, page } = params;

    if ("sort" in params) {
      sort = params.sort;
    }

    if ("filter" in params) {
      params = params.filter;
    }

    Object.keys(params).forEach(function(key) {
      params[key] = encodeURIComponent(params[key]);
    });

    return { filter: params, sort: sort, page: page, fields };
  }
}

export default EncodingFiltersService;
